import styled from 'styled-components';
import { DropdownMenu, Button } from 'reactstrap';

import { color } from '../../assets/styles/colors';
import LogoImageEE from '../../assets/img/logo_ee.png';
import LogoImageGreen from '../../assets/img/logo-login.png';

export const Bar = styled.header`
	width: 100%;
	height: 80px;
	background-color: ${color.primary};
	/* box-shadow: 8px 0px 16px rgba(0, 0, 0, 0.2); */
	${'' /* position: fixed;
	top: 0;
	left: 0; */}
	z-index: 9;
	position: fixed;
	top: 0;
	left: 0;

	.sidebar-active-icon {
		padding-left: 190px;
	}

	.sidebar-inactive-icon {
		padding-left: 0px;
	}

	@media screen and (max-width: 768px) {
		background-color: white;
	}
`;

export const Logo = styled.div`
	height: 80px;
	background-repeat: no-repeat;
	background-position: center;
	z-index: 11;
	position: fixed;
	transition: background-image 0.1s ease-in-out;

	&.logo-green{
		margin-top: -80px;
		margin-left: -195px;
		width: 145px;
		background-image: url(${LogoImageGreen});
		background-size: 130px;
	}
	&.logo-ee{
		margin-top: -80px;
		width: 55px;
		margin-left: -55px;
		background-image: url(${LogoImageEE});
		background-size: 50px;
	}
	&.logo-mobile{
		margin-top: -80px;
		width: 145px;
		background-image: url(${LogoImageGreen});
		background-size: 90px;
	}
`;

export const IconeMenu = styled.div`
	color: white;
	margin-left: 55px;
	cursor: pointer;
`;

export const Sidebar = styled.aside`
	width: ${(props) => props.active ? `245px` : `55px`};
	height: 100vh;
	padding-top: 80px;
	background-color: ${color.white};
	position: fixed;
	top: 0;
	left: 0;
	z-index: 10;
	will-change: width;
	transition: width 0.3s ease;

	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const SidebarUl = styled.ul`
	margin: 0;
	padding: 0;
	height: 100%;
	list-style: none;
	max-height: ${(props) => props.active ? `calc(100vh - 220px)` : `calc(100vh - 120px)`};
	overflow-x: hidden;
	overflow-y: auto;

	display: flex;
	flex-direction: column;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${color.secondary};
		border-radius: 5px;
		border: 1px solid ${color.white};
	}

	.final{
		margin-top: auto !important;
	}
`;

export const SidebarLi = styled.li`
	min-width: ${(props) => props.active ? `225px` : `35px`};
	height: 35px;
	border-radius: ${(props) => props.active ? `12px` : `0px`};
	padding: 15px 5px;
	margin: 2px;
	margin-left: ${(props) => props.active ? `20px` : `8px`} ;
	transition: all 0.5s ease;
	text-transform: uppercase;
	align-items: center;
	color: ${color.gray};
	display: flex;
	text-decoration: none;
	border-top: 1px solid rgba(255, 255, 255, 0.2);
	cursor: pointer;
	p {
		font-size: 10px;
		margin: 0px;
		margin-left: 10px;
		display: ${(props) => props.active ? `block` : `none`};
	}
	&:hover {
		background-color: ${(props) => props.active ? color.greenLight2 : ``} ;
		color: ${color.gray};
	}
`;

export const SibebarSub = styled.div`
	width: ${(props) => props.active ? `245px` : `55px`};
	height: 100%;
	background-color: ${color.white};
	position: fixed;
	z-index: 9;
	top: 0;
	left: 0;
	box-shadow: ${(props) => props.active && `8px 0px 16px rgba(0, 0, 0, 0.2)`};
	will-change: transform;
	transform: ${(props) =>
		props.active ? `translateX(145px)` : `translateX(-240px)`};
	pointer-events: ${(props) => (props.active ? `all` : `none`)};
	transition: transform 0.3s ease;

	& + .main-panel {
		padding-top: 80px;
	}

`;

export const ButtonIcon = styled.div`
	color: ${color.softBlack};
	cursor: pointer;

	div {
		color: ${color.gray};
	}
`;

export const ButtonCss = styled(Button)`
	font-size: 14px;
	min-height: 32px;
	font-weight: 500;
	margin: 18px;
	border-radius: 0;
	border: none;
	padding: 0;
	margin-right: '25px';
`;

export const SidebarHeader = styled.div`
	width: 100%;
	height: 80px;
	padding: 0 30px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.2);
	color: ${color.gray};
`;

export const LogoLucree = styled.div`
	height: 80px;
	width: 100px;
	background-repeat: no-repeat;
	background-position: left;

	& + svg {
		cursor: pointer;
	}
`;

export const Profile = styled.div`
	text-align: center;
	background-color: ${color.primary};
	padding: 37px;
	border-radius: 30px 0px 0px 0px;
`;

export const Picture = styled.div`
	svg {
		font-size: 150px;
	}
`;

export const DropdownMenuStyled = styled(DropdownMenu)`
	transition: none !important;
	border-radius: 30px 0px 0px 0px !important;

	.dropdown-item {
		svg {
			color: ${color.primary};
		}

		&:hover {
			text-decoration: underline;
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}

		&:focus {
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}
	}

	&:before {
		border: 0 !important;
	}

	&:after {
		border: 0 !important;
	}
	@media screen and (max-width: 590px) {
		&.fullscreen-dropdown {
			margin-bottom: 22px;
			margin-left: -5px;
			left: 0;
			right: 0;
			top:0;
			height: 80vh;
			width: 100vw;
			z-index: 99999;
		}

		.fullscreen-dropdownItem{
			margin-left: -5px;
			color: ${color.softBlack};
			border-bottom: 2px solid ${color.grayMedium};
			a {
				color: ${color.softBlack};
				display: flex;
				font-size: 16px;
				flex-direction: row;
				justify-content: flex-start;
			}
		}
		.fullscreen-dropdownSair{
			color: ${color.softBlack};
			.exit-icon{
				font-size: 30px;
			}
		}

	}
`;

export const SwitchNotification = styled.div`
	background-color: red;
	justify-content: center;
`;

export const SwitchNotificationDiv = styled.div`
	text-align: center;
	background-color: ${color.primary};
	padding: 37px;
	border-radius: 0px 0px 0px 0px;
`;

export const DropdownMenuStyledNotification = styled(DropdownMenu)`
	transition: none !important;
	border-radius: 30px 0px 0px 0px !important;

	.dropdown-item {
		svg {
			color: ${color.primary};
		}

		&:hover {
			text-decoration: underline;
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}

		&:focus {
			background-color: unset !important;
			color: ${color.softBlack} !important;
		}
	}

	&:before {
		border: 0 !important;
	}

	&:after {
		border: 0 !important;
	}
`;


export const MeusCreditosInfo = styled.div`
	padding: 20px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;

	span {
		font-size: 13px;
		font-weight: bold;
	}
	p{
		font-size: 25px;
		color: ${color.primary};
	}


	@media screen and (max-width: 768px) {
		padding: 0px;
		margin-top: 20px;
		span {
			font-size: 9px;
		}
		p{
			font-size: 17px;
		}

	}
`;
